import { customCleanEnv, url } from "envalid";

interface Env {
    ivrApisBaseUrl: string;
}

export const env = customCleanEnv(
    import.meta.env,
    {
        VITE_IVR_APIS_BASE_URL: url(),
    },
    (inputEnv): Env => ({
        ivrApisBaseUrl: inputEnv.VITE_IVR_APIS_BASE_URL,
    }),
);
